<template>
  <div class="flex items-center">
    <img
      :src="'/build/images/supervenue.svg'"
      class="mr-2"
      alt="Super Venue Badge"
      width="15"
      height="22"
      loading="lazy"
    >
    <div class="supervenue-tag">
      #Supervenue
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupervenueBadge',
};
</script>

<style lang="scss" scoped>
@use "@sass/base/variables";

.supervenue-tag {
  padding: 2px 4px;
  border: 1px solid variables.$brand-success;
  font-size: 11px;
  color: variables.$brand-success;
  font-weight: 600;
  border-radius: 4px;
  line-height: 14px;
}
</style>
